import { DashedFocusBorder } from 'jamespot-react-components';
import styled from 'styled-components';

export const CSSSquareWidgetWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
`;

export const CSSSquareWidget = styled.div<{ available: boolean }>`
    border: 1px solid ${(props) => props.theme.color.grey2};
    border-radius: 8px;
    cursor: pointer;
    padding: 12px;
    position: relative;
    opacity: ${(props) => (props.available ? '1' : '.4')};
    pointer-events: ${(props) => (props.available ? 'all' : 'none')};

    .show-on-hover {
        position: absolute;
        inset: 0;
        border-radius: 8px;
        justify-content: center;
        align-items: center;
        display: flex;
        opacity: 0;
        background-color: #ffffffe6;
    }

    &:hover {
        .show-on-hover {
            opacity: 1;
        }
    }
`;

export const CSSWidgetButton = styled.div<{ open: boolean; height: number }>`
    border: 2px solid ${(props) => props.theme.color.primary};
    height: ${(props) => (props.open ? props.height : '54')}px;
    border-radius: 8px;
    display: flex;
    justify-content: top;
    flex-direction: column;
    transition: height 0.4s;
    overflow: hidden;
    flex-direction: column;
`;

export const CSSWrapWidgetWrapper = styled.div<{ column?: boolean }>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    ${(props) => props.column && `flex-direction: column;`}
`;

export const CSSWrapTitle = styled.div`
    min-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: ${(props) => props.theme.color.primary};
    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }
`;

export const CSSWrapWidget = styled.button<{ open: boolean; index: number; full?: boolean; parentIsColumn?: boolean }>`
    display: flex;
    align-items: center;
    padding: ${(props) => (props.parentIsColumn ? '36px 16px' : '0 10px')};
    gap: 10px;
    width: 40%;
    border: 1px solid ${(props) => props.theme.color.grey1};
    border-radius: 8px;
    transition: opacity 0.4s ease ${(props) => props.index * 40}ms;
    opacity: ${(props) => (props.open ? 1 : 0)};
    img {
        width: 40px;
    }
    ${(props) => props.full && `flex: 1; width: 100%;`}
    ${(props) => props.parentIsColumn && `flex-basis: 72px;`}
    ${(props) => !props.parentIsColumn && `height: 72px;`}
    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }

    ${DashedFocusBorder()}
`;

export const Flex = styled.div<{ direction: 'row' | 'column'; gap?: number }>`
    display: flex;
    flex-direction: ${(props) => (props.direction === 'row' ? 'row' : 'column')};
    align-items: ${(props) => (props.direction === 'row' ? 'center' : 'flex-start')};
    justify-content: ${(props) => (props.direction === 'row' ? 'flex-start' : 'center')};
    flex: 1;
    ${(props) => props.gap && `gap:${props.gap}px`}
`;
